import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, IDLE, PENDING } from "const"
import { hasAccess, StateType } from "client/utils"
import {
    PRM_ACCOUNT,
    StoreType,
    AccountProps,
    LoadAccountById,
    setAccountEdit,
    setAccountReloadEdit,
    initAccount,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    accountId = null,
}: AccountProps) => {
    const account = useSelector((state: StoreType) => state.account.accountEdit)
    const reloadEdit = useSelector((state: StoreType) => state.account.reloadEdit)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const targetAccountId = userData.accountId === 1 ? accountId : userData.accountId

    const reload = () => {
        dispatch(setAccountReloadEdit(false))
        setTimeout(() => {
            dispatch(setAccountReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (targetAccountId === 0) {
            dispatch(setAccountEdit(initAccount))
            reload()
        } else {
            setLoadState(PENDING)
            LoadAccountById(targetAccountId).then((res) => {
                dispatch(setAccountEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const editAccess = hasAccess(PRM_ACCOUNT, EDIT)

    if (!editAccess) return <AccessDenied />
    if (!account) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {account.id ? `${lang.editAccount} # ${account.id}` : lang.addAccount}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form account={account} />
                }
                {
                    reloadEdit
                    && <Form account={account} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
